// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/gateway/web/myprofile/v1/auth.proto (package gdx.gateway.web.myprofile.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * Available response codes.
 *
 * @generated from enum gdx.gateway.web.myprofile.v1.ValidateEmailResponseCode
 */
export enum ValidateEmailResponseCode {
  /**
   * @generated from enum value: VALIDATE_EMAIL_RESPONSE_CODE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: VALIDATE_EMAIL_RESPONSE_CODE_GOOD = 1;
   */
  GOOD = 1,

  /**
   * @generated from enum value: VALIDATE_EMAIL_RESPONSE_CODE_EXISTS = 2;
   */
  EXISTS = 2,

  /**
   * @generated from enum value: VALIDATE_EMAIL_RESPONSE_CODE_BAD = 3;
   */
  BAD = 3,

  /**
   * @generated from enum value: VALIDATE_EMAIL_RESPONSE_CODE_RISKY = 4;
   */
  RISKY = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(ValidateEmailResponseCode)
proto3.util.setEnumType(ValidateEmailResponseCode, "gdx.gateway.web.myprofile.v1.ValidateEmailResponseCode", [
  { no: 0, name: "VALIDATE_EMAIL_RESPONSE_CODE_INVALID" },
  { no: 1, name: "VALIDATE_EMAIL_RESPONSE_CODE_GOOD" },
  { no: 2, name: "VALIDATE_EMAIL_RESPONSE_CODE_EXISTS" },
  { no: 3, name: "VALIDATE_EMAIL_RESPONSE_CODE_BAD" },
  { no: 4, name: "VALIDATE_EMAIL_RESPONSE_CODE_RISKY" },
]);

/**
 * Used during sign up or sign in process in cases when user authenticated via external auth systems like facebook, google, etc.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.ExternalCredential
 */
export class ExternalCredential extends Message<ExternalCredential> {
  /**
   * @generated from field: string provider = 1;
   */
  provider = "";

  /**
   * @generated from field: string session_id = 2;
   */
  sessionId = "";

  constructor(data?: PartialMessage<ExternalCredential>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.ExternalCredential";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "provider", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExternalCredential {
    return new ExternalCredential().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExternalCredential {
    return new ExternalCredential().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExternalCredential {
    return new ExternalCredential().fromJsonString(jsonString, options);
  }

  static equals(a: ExternalCredential | PlainMessage<ExternalCredential> | undefined, b: ExternalCredential | PlainMessage<ExternalCredential> | undefined): boolean {
    return proto3.util.equals(ExternalCredential, a, b);
  }
}

/**
 * Used during sign up process when user tries to authenticate via email-password pair.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.EmailCredential
 */
export class EmailCredential extends Message<EmailCredential> {
  /**
   * @generated from field: string email = 1;
   */
  email = "";

  /**
   * @generated from field: string password = 2;
   */
  password = "";

  constructor(data?: PartialMessage<EmailCredential>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.EmailCredential";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "password", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EmailCredential {
    return new EmailCredential().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EmailCredential {
    return new EmailCredential().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EmailCredential {
    return new EmailCredential().fromJsonString(jsonString, options);
  }

  static equals(a: EmailCredential | PlainMessage<EmailCredential> | undefined, b: EmailCredential | PlainMessage<EmailCredential> | undefined): boolean {
    return proto3.util.equals(EmailCredential, a, b);
  }
}

/**
 * Used during autologin link sing in.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.OneTimeHashCredential
 */
export class OneTimeHashCredential extends Message<OneTimeHashCredential> {
  /**
   * @generated from field: string hash = 1;
   */
  hash = "";

  constructor(data?: PartialMessage<OneTimeHashCredential>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.OneTimeHashCredential";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "hash", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): OneTimeHashCredential {
    return new OneTimeHashCredential().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): OneTimeHashCredential {
    return new OneTimeHashCredential().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): OneTimeHashCredential {
    return new OneTimeHashCredential().fromJsonString(jsonString, options);
  }

  static equals(a: OneTimeHashCredential | PlainMessage<OneTimeHashCredential> | undefined, b: OneTimeHashCredential | PlainMessage<OneTimeHashCredential> | undefined): boolean {
    return proto3.util.equals(OneTimeHashCredential, a, b);
  }
}

/**
 * Used during access token update process.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.RefreshTokenCredential
 */
export class RefreshTokenCredential extends Message<RefreshTokenCredential> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  constructor(data?: PartialMessage<RefreshTokenCredential>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.RefreshTokenCredential";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): RefreshTokenCredential {
    return new RefreshTokenCredential().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): RefreshTokenCredential {
    return new RefreshTokenCredential().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): RefreshTokenCredential {
    return new RefreshTokenCredential().fromJsonString(jsonString, options);
  }

  static equals(a: RefreshTokenCredential | PlainMessage<RefreshTokenCredential> | undefined, b: RefreshTokenCredential | PlainMessage<RefreshTokenCredential> | undefined): boolean {
    return proto3.util.equals(RefreshTokenCredential, a, b);
  }
}

/**
 * Access or refresh token representation.
 *
 * @generated from message gdx.gateway.web.myprofile.v1.Token
 */
export class Token extends Message<Token> {
  /**
   * @generated from field: string token = 1;
   */
  token = "";

  /**
   * @generated from field: google.protobuf.Timestamp expire_time = 2;
   */
  expireTime?: Timestamp;

  constructor(data?: PartialMessage<Token>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.Token";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "expire_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Token {
    return new Token().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Token {
    return new Token().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Token {
    return new Token().fromJsonString(jsonString, options);
  }

  static equals(a: Token | PlainMessage<Token> | undefined, b: Token | PlainMessage<Token> | undefined): boolean {
    return proto3.util.equals(Token, a, b);
  }
}

/**
 * Message means successful user registration (via websocket).
 *
 * @generated from message gdx.gateway.web.myprofile.v1.UserRegistration
 */
export class UserRegistration extends Message<UserRegistration> {
  /**
   * @generated from field: string user_id = 1;
   */
  userId = "";

  /**
   * @generated from field: string token = 2;
   */
  token = "";

  /**
   * @generated from field: bool is_registered = 3;
   */
  isRegistered = false;

  /**
   * @generated from field: string fail_reason = 4;
   */
  failReason = "";

  constructor(data?: PartialMessage<UserRegistration>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.gateway.web.myprofile.v1.UserRegistration";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_registered", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "fail_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UserRegistration {
    return new UserRegistration().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UserRegistration {
    return new UserRegistration().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UserRegistration {
    return new UserRegistration().fromJsonString(jsonString, options);
  }

  static equals(a: UserRegistration | PlainMessage<UserRegistration> | undefined, b: UserRegistration | PlainMessage<UserRegistration> | undefined): boolean {
    return proto3.util.equals(UserRegistration, a, b);
  }
}

